module.exports = __webpack_public_path__ + "media/images/sec_3-3-03b1417eb74207737628c2a5ffb7f911.png";